/**
 * Text as every literal check compares it: trimmed, each whitespace run one
 * space (code decides whitespace, owner 10-21). The one owner in TypeScript;
 * the Python twin is `models.questionnaire.blank_text.normal_text`, over the
 * same characters (ECMAScript's `\s`, which `blank_text.WHITESPACE_CLASS`
 * states). Never folds case, quotes or accents: those are identity decisions
 * of their own readers.
 */
export function normalText(value: unknown): string {
  return typeof value === "string" ? value.replace(/\s+/g, " ").trim() : "";
}
